import React, { useMemo, useState } from 'react';
import { FileTextIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
import { OrdersTable } from '../components/OrdersTable';
import { OrderFilters } from '../components/OrderFilters';
import { Card } from '../components/ui/Card';
import { OrderFilters as OrderFiltersType } from '../types';
import { mockOrders, mockNotes } from '../data/mockData';
export function OrdersDashboard() {
  const [filters, setFilters] = useState<OrderFiltersType>({
    search: '',
    orderType: 'all',
    status: 'all',
    assignedTo: '',
    dateFrom: '',
    dateTo: ''
  });
  const filteredOrders = useMemo(() => {
    return mockOrders.filter(order => {
      if (filters.search) {
        const searchLower = filters.search.toLowerCase();
        if (!order.loanNumber.toLowerCase().includes(searchLower) && !order.borrowerName.toLowerCase().includes(searchLower) && !(order.loanName || '').toLowerCase().includes(searchLower)) {
          return false;
        }
      }
      if (filters.orderType !== 'all' && order.orderType !== filters.orderType) {
        return false;
      }
      if (filters.status !== 'all' && order.status !== filters.status) {
        return false;
      }
      if (filters.assignedTo && !order.assignedTo.toLowerCase().includes(filters.assignedTo.toLowerCase())) {
        return false;
      }
      return true;
    });
  }, [filters]);
  const stats = useMemo(() => {
    return {
      total: mockOrders.length,
      pending: mockOrders.filter(o => o.status === 'pending' || o.status === 'ordered').length,
      inProgress: mockOrders.filter(o => o.status === 'received' || o.status === 'reviewed').length,
      complete: mockOrders.filter(o => o.status === 'complete').length
    };
  }, []);
  return <div className="space-y-12" data-id="element-605">
      <div className="space-y-2" data-id="element-606">
        <h1 className="text-5xl font-semibold text-slate-900 tracking-tight" data-id="element-607">
          Orders
        </h1>
        <p className="text-slate-500 text-lg" data-id="element-608">
          Manage loan orders and track their progress
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-609">
        <Card className="p-8" data-id="element-610">
          <div className="flex items-start justify-between" data-id="element-611">
            <div className="space-y-2" data-id="element-612">
              <p className="text-sm text-slate-500 font-medium tracking-wide uppercase" data-id="element-613">
                Total Orders
              </p>
              <p className="text-4xl font-semibold text-slate-900" data-id="element-614">
                {stats.total}
              </p>
            </div>
            <FileTextIcon className="w-10 h-10 text-slate-300" strokeWidth={1.5} data-id="element-615" />
          </div>
        </Card>

        <Card className="p-8" data-id="element-616">
          <div className="flex items-start justify-between" data-id="element-617">
            <div className="space-y-2" data-id="element-618">
              <p className="text-sm text-slate-500 font-medium tracking-wide uppercase" data-id="element-619">
                Pending
              </p>
              <p className="text-4xl font-semibold text-slate-900" data-id="element-620">
                {stats.pending}
              </p>
            </div>
            <ClockIcon className="w-10 h-10 text-slate-300" strokeWidth={1.5} data-id="element-621" />
          </div>
        </Card>

        <Card className="p-8" data-id="element-622">
          <div className="flex items-start justify-between" data-id="element-623">
            <div className="space-y-2" data-id="element-624">
              <p className="text-sm text-slate-500 font-medium tracking-wide uppercase" data-id="element-625">
                In Progress
              </p>
              <p className="text-4xl font-semibold text-slate-900" data-id="element-626">
                {stats.inProgress}
              </p>
            </div>
            <ClockIcon className="w-10 h-10 text-slate-300" strokeWidth={1.5} data-id="element-627" />
          </div>
        </Card>

        <Card className="p-8" data-id="element-628">
          <div className="flex items-start justify-between" data-id="element-629">
            <div className="space-y-2" data-id="element-630">
              <p className="text-sm text-slate-500 font-medium tracking-wide uppercase" data-id="element-631">
                Complete
              </p>
              <p className="text-4xl font-semibold text-slate-900" data-id="element-632">
                {stats.complete}
              </p>
            </div>
            <CheckCircleIcon className="w-10 h-10 text-slate-900" strokeWidth={1.5} data-id="element-633" />
          </div>
        </Card>
      </div>

      <OrderFilters filters={filters} onFiltersChange={setFilters} data-id="element-634" />

      <OrdersTable orders={filteredOrders} notes={mockNotes} data-id="element-635" />
    </div>;
}